import { makeApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/** ***************** GET PROFIT AND LOSS DETAILS START *********************** */
export const prifitAndLossDetailsget = (addData: any) => {
	const data = {
		ProfitAndLossToken: addData,
	};
	const url = `${FIN_API_URL}getProfitAndLossDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET PROFIT AND LOSS DETAILS END *********************** */
